import Axios from "axios"
import { SkResponse } from "../models/SkResponse"
import { MakeUrl } from "./Urls"

export const GetAllTagsAction = async (): Promise<SkResponse<string[]>> => await Axios.get(MakeUrl(`/tags/all`));
export const SeedTagsAction = async (): Promise<SkResponse<{ total: number, created: number, deleted: number }>> => await Axios.put(MakeUrl(`/tags/seed`));
